import { Component, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Customer, CustomerService } from '../../services/customer';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth-service';
import { Subject, takeUntil } from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { RouteService } from '../../services/routes';

@Component({
  selector: 'app-customer-search',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule
  ],
  templateUrl: './customer-search-component.html', // Update the template reference
  styleUrls: ['./customer-search-component.scss'] // Update the style reference
})
export class CustomerSearchComponent implements OnInit, OnDestroy {
  @Output() customerSelected = new EventEmitter<Customer | null>(); // Emit selected customer
  private destroy$ = new Subject<void>();

  customers: Customer[] = [];
  filteredCustomers: Customer[] = [];
  searchTerm: string = '';
  selectedCustomer: Customer | null = null;

  constructor(
    private customerService: CustomerService,
    private routeService: RouteService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    // Fetch customers and filter them based on routeId
    this.authService.getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe(userInfo => {
        this.customerService.get()
          .pipe(takeUntil(this.destroy$))
          .subscribe(customers => {
            // Filter customers based on routeIds (or show all if Sales Admin)
            this.routeService.get()
              .pipe(takeUntil(this.destroy$))
              .subscribe(routes => {
                let lineIds = routes.filter(r => userInfo?.routeIds.includes(r.id)).flatMap(r => r.lineIds);
                this.customers = userInfo?.isSalesAdmin ? customers : customers.filter(c => lineIds.includes(c.routeId));
                this.filteredCustomers = [...this.customers]; // Initialize filteredCustomers with all customers
              });
          });
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Search function to filter customers by name or phone
  searchCustomers(): void {
    if (this.searchTerm.trim()) {
      this.filteredCustomers = this.customers.filter(customer => {
        // Ensure customer.name is a string and check if it contains the search term
        const customerName = customer.name ? customer.name.toLowerCase() : '';
        const customerPhone = customer.phone ? customer.phone.toLowerCase() : '';

        return customerName.includes(this.searchTerm.toLowerCase()) || customerPhone.includes(this.searchTerm.toLowerCase());
      });
    } else {
      this.filteredCustomers = [...this.customers]; // If no search term, show all customers
    }
  }


  selectCustomer(customerName: string): void {
    // Find the customer object based on name
    const customer = this.customers.find(c => c.name === customerName);
    if (customer) {
      this.selectedCustomer = customer;
      this.customerSelected.emit(customer);
    }
  }

  clearSelection(): void {
    this.selectedCustomer = null;  // Clear the selected customer
    this.searchTerm = '';  // Reset the search term
    this.filteredCustomers = [...this.customers];  // Reset filtered customers list (optional)
    this.customerSelected.emit(null);
  }

}
